var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"singatureCanvas","width":"580","height":"100"},on:{"mousedown":_vm.mousedown,"mousemove":_vm.mousemove,"mouseup":function($event){_vm.sign = false},"mouseout":function($event){_vm.sign = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }